import React from "react"
import styled from "styled-components"
import { up } from "styled-breakpoints"

export default class InstagramMedia extends React.Component {

  renderVideo(){

    const { video } = this.props

    return (
      <Video muted autoPlay playsInline loop>
        <source src={video} type="video/mp4" />
      </Video>
    )

  }

  renderImage(){

    const { thumbnail } = this.props

    return (
      <Image src={thumbnail} />
    )

  }

  render(){

    const { type, url } = this.props

    return(
      <React.Fragment>
      <a href={url} target="_blank">
      {type === "GraphImage" && this.renderImage()}  
      {type === "GraphSidecar" && this.renderImage()}  
      {type === "GraphVideo" && this.renderVideo()}  
      </a>
      </React.Fragment>
    )

  }

}

const Image = styled.img`
  width:100%;
`

const Video = styled.video`
  width:100%;
`